import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { AXIS_LINE_OFFSET_X } from "../constants";

const { carbon } = colorsPalettes;

export const LineWrapper = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 5px;
`;

export const Line = styled.span<{ background?: string }>`
    display: flex;
    height: 5px;
    width: 100%;
    background: ${({ background }) => background || carbon[50]};
    border-radius: 8px;
`;

const startLineBase = styled.span`
    position: absolute;
    display: flex;
    background: ${carbon[50]};
    width: 1px;
    height: 12px;
    top: 4px;
`;

export const StartLine = styled(startLineBase)`
    right: ${AXIS_LINE_OFFSET_X};
`;

export const EndLine = styled(startLineBase)`
    left: ${AXIS_LINE_OFFSET_X};
`;

export const NumberValue = styled.p`
    ${setFontVariant("caption", carbon[400])};
    margin: 0;
`;

export const NumberWrapper = styled.div<{ isStart: boolean }>`
    position: absolute;
    width: max-content;

    top: 16px;
    left: ${({ isStart }) => (isStart ? AXIS_LINE_OFFSET_X : "100%")};
    transform: ${({ isStart }) => (isStart ? "translateX(0)" : `translateX(calc(-100% - ${AXIS_LINE_OFFSET_X}))`)};
`;
